import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=f04c3900&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=f04c3900&prod&lang=scss"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=f04c3900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c3900",
  null
  
)

export default component.exports